import {inject, DOM, customAttribute, bindable, bindingMode} from 'aurelia-framework';
import keyCode from 'keycode';
import {isArray, find, findIndex, noop} from 'lodash';

@inject(DOM.Element)
@customAttribute('movement-list')
export class MovementList {

    @bindable({
      defaultBindingMode: bindingMode.oneWay
    }) data = [];

    @bindable({
      defaultBindingMode: bindingMode.twoWay
    }) highlightedValue: any = {};

    @bindable movement = noop;

    @bindable enter = noop;

  private __listener: EventListener;

  constructor(private __element: Element) {
  }

  bind() {
    this.__element.addEventListener('keyup', this.__listener = (e) => this.keyUp(e));
  }

  unbind() {
    this.__element.removeEventListener('keyup', this.__listener);
  }


  keyUp(e) {
    switch (keyCode(e)) {
    case 'up' :
      this.setNextValue(i => i - 1);
      break;
    case 'down' :
      this.setNextValue(i => i + 1);
      break;
    case 'enter' :
      this.selectValue();
      break;
    }
  }

  selectValue() {
    let value = find(this.data, { 'id': this.highlightedValue.id });

    if (value) {
      this.enter({ user: value});
    }
  }

    /**
     * @param {Function} nextIndex
     */
  setNextValue(nextIndex) {
    let highlightedIndex = findIndex(this.data, { 'id': this.highlightedValue.id });
    let index = nextIndex(highlightedIndex);

    if (index >= 0 && index < this.data.length) {
      this.highlightedValue = this.data[index];
    }
  }

  dataChanged(newValue, oldValue) {
    if (isArray(newValue)) {
      let user = find(newValue, { 'id': this.highlightedValue.id });

      if (!user) {
        this.movement({
          newValue: user,
          oldValue: this.highlightedValue
        });
      }
    }
  }

  highlightedValueChanged(newValue, oldValue) {
    this.movement({
      newValue: newValue,
      oldValue: oldValue
    });
  }
}
